import { decodeJWT } from '@moko/utils/src/authTokenValidation';

// Match getFmsToken/getAuthHeader: portal requests use `token`, while other apps
// may retain a different session under `auth.accessToken` on the same origin.
const claims = (): Record<string, unknown> | null => {
  const token = localStorage.getItem('token');
  return token ? decodeJWT(token) : null;
};
export function getPortalActiveRole(): string | null {
  const data = claims();
  const raw = data?.roles;
  const roles = Array.isArray(raw)
    ? raw.filter((r): r is string => typeof r === 'string')
    : typeof raw === 'string'
    ? raw.split(/[,;\s]+/).filter(Boolean)
    : [];
  const selected = data?.defaultRole;
  return typeof selected === 'string' && selected
    ? roles.find((r) => r.toLowerCase() === selected.toLowerCase()) ?? null
    : roles[0] ?? null;
}
export function getPortalTenantId(): number | undefined {
  const value = Number(claims()?.tenantId);
  return Number.isInteger(value) && value > 0 ? value : undefined;
}
